var map = {
	"./logo-alphabet.svg": 528,
	"./logo-amazon-2.svg": 529,
	"./logo-amazon.svg": 553,
	"./logo-azercell.svg": 554,
	"./logo-bank-of-america.svg": 555,
	"./logo-barclays.svg": 556,
	"./logo-bbc.svg": 557,
	"./logo-bloomberg.svg": 530,
	"./logo-bnp-paribas.svg": 558,
	"./logo-booking.svg": 559,
	"./logo-citibank.svg": 560,
	"./logo-cnbc.svg": 531,
	"./logo-cnbc2.svg": 561,
	"./logo-coca-cola-auto.svg": 532,
	"./logo-coca-cola-white.svg": 1433,
	"./logo-coca-cola.svg": 562,
	"./logo-deloitte.svg": 563,
	"./logo-experian.svg": 564,
	"./logo-facebook.svg": 565,
	"./logo-forbes.svg": 533,
	"./logo-g.svg": 1434,
	"./logo-goldman-sachs-new.svg": 566,
	"./logo-goldman-sachs.svg": 1313,
	"./logo-google-new.svg": 567,
	"./logo-google.svg": 568,
	"./logo-h.svg": 569,
	"./logo-henkel.svg": 570,
	"./logo-hsbc-new.svg": 571,
	"./logo-hsbc.svg": 1314,
	"./logo-ikea-new.svg": 572,
	"./logo-ikea.svg": 1435,
	"./logo-infineon.svg": 573,
	"./logo-instagram-icon.svg": 534,
	"./logo-instagram.svg": 574,
	"./logo-jp-morgan.svg": 575,
	"./logo-jti.svg": 576,
	"./logo-linkedin.svg": 577,
	"./logo-meta-new.svg": 535,
	"./logo-meta.svg": 1315,
	"./logo-morgan-stanley-new.svg": 578,
	"./logo-morgan-stanley.svg": 1316,
	"./logo-netflix.svg": 1317,
	"./logo-oracle.svg": 536,
	"./logo-paypal.svg": 579,
	"./logo-pwc-new.svg": 537,
	"./logo-pwc.svg": 1436,
	"./logo-spotify.svg": 1318,
	"./logo-tesla.svg": 580,
	"./logo-usa-today.svg": 538,
	"./logo-visa.svg": 581,
	"./logo-walmart.svg": 539,
	"./logo-wsj.svg": 540,
	"./logo-youtube.svg": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1219;